/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {GenericObject} from '@ion/core/src/types/entities';
import {
  useSCIUpdateSettings,
  UseSCIUpdateSettingsResult
} from './hooks/useSCIUpdateSettings';
import {BulkSCIUpdateProps} from './BulkSCIUpdateDetails';

export interface SCIUpdateProps extends BulkSCIUpdateProps {
  setTaskNickNameAction: (action: string) => void;
  entitySelectionFormState: GenericObject;
}

/**
 * Hook for managing SCI Update container.
 */
export const useSCIUpdate = ({
  setTaskNickNameAction,
  setSelectedSCIDevices,
  setSelectedSCITypes,
  setSelectedDeviceType,
  entitySelectionFormState,
  selectedRowEntities,
  bulkImportParams,
  entity
}: SCIUpdateProps): UseSCIUpdateSettingsResult => {
  const {
    setFormState,
    formState,
    setShowSnackBar,
    showSnackBar,
    setErrorMessage,
    errorMessage,
    noSCIDevice,
    setUpdatedSCISettings,
    updatedSCISettings,
    setBulkSCISetting,
    bulkSCISetting,
    activeStep,
    typeOptions,
    onTypeChange,
    deviceTypes
  } = useSCIUpdateSettings({
    setTaskNickNameAction,
    setSelectedSCIDevices,
    setSelectedDeviceType,
    setSelectedSCITypes,
    entitySelectionFormState,
    selectedRowEntities,
    bulkImportParams,
    entity
  });

  return {
    setFormState,
    formState,
    setShowSnackBar,
    showSnackBar,
    setErrorMessage,
    errorMessage,
    noSCIDevice,
    setUpdatedSCISettings,
    updatedSCISettings,
    setBulkSCISetting,
    bulkSCISetting,
    activeStep,
    typeOptions,
    onTypeChange,
    deviceTypes
  };
};

export default useSCIUpdate;
